import React from 'react';
import Styled from 'styled-components';
import * as color from '../colors';
import flower from '../../assets/icon/flower-alt.svg';
import morning from '../../assets/icon/morning-alt.svg';
import afternoon from '../../assets/icon/afternoon-alt.svg';
import evening from '../../assets/icon/evening-alt.svg';

const Images = { morning, afternoon, evening };

const Article = Styled.article`
display: block;
background-color:${(props) => (props.selected ? color.white : color.tertiary)};
display: flex;
justify-content: space-between;
align-items: center;
padding: 1rem 5rem;
border-radius: 3px;
max-width: 50rem;
border-top:solid 1px ${color.tertiaryAlt};
&:hover{
background-color:${color.lightAlt};
cursor: pointer;
border-color:${color.light}
};
`;
const ArticleText = Styled.div`
color:${color.primary};
`;
const ArticleDate = Styled.h4`
font-size: 1.5rem;
margin-bottom: 1rem;
`;
const ArticleList = Styled.span`
display: flex;
align-items:center;
justify-content: flex-start;
font-size: 1.8rem;
margin: .5rem 0;
img{margin-right: 1rem; height:1.5rem; width: 1.5rem;};
`;
const ArticleAvatar = Styled.figure`
height:8rem;
width:8rem;
display: block;
border-radius: 5px;
background-color: ${color.primary};
overflow:hidden;
img{width: 100%;height:100%;object-fit:cover}
`;

const ServiceListItem = ({ date, type, times, image }) => {
  return (
    <Article selected={false}>
      <ArticleText>
        <ArticleDate>{date}</ArticleDate>
        <ArticleList>
          <img src={flower} alt="" />
          {type}
        </ArticleList>
        {times.map((time) => (
          <ArticleList>
            <img src={Images[time.toLowerCase()]} alt="" />
            {time}
          </ArticleList>
        ))}
      </ArticleText>
      {image && (
        <ArticleAvatar>
          <img src={image} alt="" />
        </ArticleAvatar>
      )}
    </Article>
  );
};

export default ServiceListItem;
